/* eslint-disable @typescript-eslint/no-explicit-any */
import { ALL_SELECT_LABEL } from '../../../utils/constants/global-constants'
import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { and, isArchivedFilter } from './data'

interface Attachment {
  blobs: []
  itemKey: string
}
interface KnowledgeBase {
  AssignedComponent: string
  'AssignedComponent/MetadataValue': string
  AssignedComponentCode: number
  Attachments: Attachment[]
  Category: string
  'Category/MetadataValue': string
  CategoryCode: number
  Description: string
  Id: string
  IsArchived: boolean
  ItemCreated: string
  ItemCreatedBy: string
  ItemModified: string
  ItemModifiedBy: string
  MAJCOM: string
  'MAJCOM/MetadataValue': string
  MAJCOMCode: number
  Section: string
  'Section/MetadataValue': string
  SectionCode: number
  Tags: string
  Title: string
  eKey: string
  eTag: string
}
interface KnowledgeBaseFetchArgs {
  isArchived: false | null | true
}
const LIST_NAME = 'KnowledgeGraphList'
const COLUMN_NAMES = {
  AssignedComponent: 'AssignedComponent',
  AssignedComponentCode: 'AssignedComponentCode',
  Category: 'Category',
  CategoryCodes: 'CategoryCodes',
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  Section: 'Section',
  SectionCodes: 'SectionCodes',
  ServicingMAJCOM: 'ServicingMAJCOM',
  ServicingMAJCOMCode: 'ServicingMAJCOMCode',
  Squadron: 'Squadron',
  Tags: 'Tags',
  Title: 'Title',
}
const constructKnowledgeBaseFilter = (args: KnowledgeBaseFetchArgs): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchived ?? null))
  const filter = and(...filters)
  return filter
}

const getKnowledgeBase = async (
  args: KnowledgeBaseFetchArgs
): Promise<KnowledgeBase[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructKnowledgeBaseFilter(args)
  const items: any = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.Section,
      COLUMN_NAMES.Category,
      COLUMN_NAMES.AssignedComponentCode,
      COLUMN_NAMES.CategoryCodes,
      COLUMN_NAMES.Description,
      COLUMN_NAMES.EKey,
      COLUMN_NAMES.ETag,
      COLUMN_NAMES.IsArchived,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.ServicingMAJCOMCode,
      COLUMN_NAMES.SectionCodes,
      COLUMN_NAMES.Squadron,
      COLUMN_NAMES.Tags,
      COLUMN_NAMES.Title,
      COLUMN_NAMES.ItemCreatedByEmail,
      COLUMN_NAMES.ItemCreatedByEDIPI,
      COLUMN_NAMES.ItemCreatedByFirstName,
      COLUMN_NAMES.ItemCreatedByLastName,
      COLUMN_NAMES.ItemModifiedByEDIPI,
      COLUMN_NAMES.ItemModifiedByEmail,
      COLUMN_NAMES.ItemModifiedByFirstName,
      COLUMN_NAMES.ItemModifiedByLastName,
      'AssignedComponent/MetadataValue',
      'ServicingMAJCOM/MetadataValue'
    )
    .expand(
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.AssignedComponent,
      COLUMN_NAMES.ServicingMAJCOM
    )
    .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.ItemModified }])
    .get()

    items.forEach((element: KnowledgeBase) => {
      element.AssignedComponent = element['AssignedComponent/MetadataValue']
      ? element['AssignedComponent/MetadataValue']
      : ALL_SELECT_LABEL
      element.ServicingMAJCOM = element['ServicingMAJCOM/MetadataValue']
        ? element['ServicingMAJCOM/MetadataValue']
        : ALL_SELECT_LABEL
      element.Category = JSON.parse(element.Category)
      element.Section = JSON.parse(element.Section)
      element.CategoryCodes = JSON.parse(element.CategoryCodes)
      element.SectionCodes = JSON.parse(element.SectionCodes)
    })
    return [...items] as KnowledgeBase[]
  }
 
const saveOrUpdateKnowledgeBase = async (
  item
): Promise<KnowledgeBase> => {
  try {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    const actual = (await list.addOrUpdateItem(item)) as KnowledgeBase
    return actual
  } catch (error) {
    console.error(
      'An error occurred while saving or updating the knowledge base:',
      error
      )
    return {} as KnowledgeBase
  }
}
export {
  type Attachment,
  COLUMN_NAMES,
  type KnowledgeBase,
  type KnowledgeBaseFetchArgs,
  LIST_NAME,
  getKnowledgeBase,
  saveOrUpdateKnowledgeBase
}
